// @flow
import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

const messages: { [key: string]: MessageDescriptor } = defineMessages({
  infoButtonLabel: {
    id: 'boxFileRequest.infoButton.buttonLabel',
    description: 'Label for info button in error modal',
    defaultMessage: 'Learn More',
  },
});

export default messages;
